var $dd1a9a73340c793e$exports = {};
$dd1a9a73340c793e$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Verdien m\xE5 v\xE6re ".concat(args.maxValue, " eller tidligere.");
  },
  "rangeReversed": "Startdatoen m\xE5 v\xE6re f\xF8r sluttdatoen.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Verdien m\xE5 v\xE6re ".concat(args.minValue, " eller senere.");
  },
  "unavailableDate": "Valgt dato utilgjengelig."
};
export { $dd1a9a73340c793e$exports as default };